import React from 'react';
import { Link } from 'react-router-dom';
import { PublicHomeNav } from '../../Common/PublicComponents/PublicHomeNav';
import { PublicSkipContentLink } from '../../Common/PublicComponents/PublicSkipContentLink';
import { PUBLIC_SITE_URL_ACTIVE_MAP } from '../../../App';

export function PublicAbout() {

    return (
        <>
            <div className="wrapper">
                <PublicSkipContentLink />
                <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
                <div className="main" id="content">
                    <section className="section section-features section-offset">
                        <header className="section__head">
                            <div className="shell">
                                <div className="section__head-inner">
                                    <h1>About</h1>

                                    <nav className="breadcrumbs section__breadcrumbs">
                                        <ul>
                                            <li>
                                                <Link to='/'>Home</Link>
                                            </li>
                                            <li className="is-current" style={{ marginLeft: '0.5rem' }}>About</li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </header>
                        <div className="section__body">
                            <div className="shell">
                                <div className="section__body-inner pain-html" style={{ marginLeft: '2rem' }}>
                                    <h2>Who We Are</h2>
                                    <hr ></hr>
                                    <p>
                                        The Department on Disability Services (DDS) provides the residents of the District of Columbia with information, oversight and coordination of services for people with disabilities and those who support them, such as service providers and employers. DDS supports the District’s Disability Determination Division where Social Security Disability Insurance claims determinations are processed.
                                    </p>
                                    <p>
                                        Two Administrations oversee and coordinate services for residents with disabilities through a network of private and non-profit providers:
                                    </p>
                                    <ul>
                                        <li>Developmental Disabilities Administration (DDA)</li>
                                        <li>Rehabilitation Services Administration (RSA)</li>
                                    </ul>
                                    <p>
                                        The DDA ensures that residents with intellectual disabilities receive the services and supports they need to lead self-determined and valued lives in the community. DDA delivers:
                                    </p>
                                    <ul>
                                        <li>Outreach and service coordination services;</li>
                                        <li>Development and management of a provider network delivering community residential, day, vocational, employment and individual and family support services; and</li>
                                        <li>Operation of a comprehensive quality management program.</li>
                                    </ul>
                                    <p>
                                        The RSA focuses on employment, ensuring that persons with disabilities achieve a greater quality of life by obtaining and sustaining employment, economic self-sufficiency and independence. RSA achieves this through:
                                    </p>
                                    <ul>
                                        <li>Employment marketing and placement services,</li>
                                        <li>Vocational rehabilitation,</li>
                                        <li>Inclusive business enterprises and</li>
                                        <li>Support of the DC Center for Independent Living.</li>
                                    </ul>
                                    <h2>What is DDS VRR</h2>
                                    <hr></hr>
                                    <p>
                                        The Vocational Rehabilitation (VR) program provides vocational and rehabilitative services to individuals with disabilities to help them prepare for, secure, regain or retain employment. Persons with disabilities face some challenges in today’s modern workplace. We believe that people with disabilities, given the right opportunities, can work and be fully integrated into mainstream society and the workplace. Vocational rehabilitation services can reduce or remove barriers to employment.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}